import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

declare global {
    interface Window {
        // eslint-disable-next-line
        klaviyo?: any;
    }
}

@Component
export class KlaviyoPopup extends ThemeComponent {

    @Ref button!: HTMLButtonElement;
    @Prop formId!: string;

    init() {
        if (window.klaviyo) {
            this.$listen(this.button, 'click', () => {
                window.klaviyo.openForm(this.formId);
            });
        }
    }
}
